import { api } from './apiClient';

export const createFaq = async (question, answer, order) => {
  try {
    const requestBody = {
      question,
      answer,
      order,
    };

    const response = await api.post('/api/v1/admin/faqs', requestBody);

    return response.data;
  } catch (error) {
    if (error.response) {
      // Check for detailed validation errors
      const errorData = error.response.data;
      if (errorData?.errors && typeof errorData.errors === 'object') {
        // If there are field-specific errors, include them in the error message
        const errorMessages = Object.entries(errorData.errors)
          .map(([field, msg]) => `${field}: ${msg}`)
          .join(', ');
        throw new Error(errorMessages || errorData.message || `Server error: ${error.response.status}`);
      }
      const message = errorData?.message || `Server error: ${error.response.status}`;
      throw new Error(message);
    } else if (error.request) {
      throw new Error('Unable to reach the server. Please check your internet connection or try again later.');
    } else {
      throw new Error(error.message || 'An unexpected error occurred');
    }
  }
};

export const fetchFaqList = async (page = 1, pageSize = 100, searchtext = '') => {
  try {
    const requestBody = {
      pagination: {
        page,
        pageSize,
        sort: { order: 1 }
      },
      searchtext: searchtext || ''
    };

    const response = await api.post('/api/v1/admin/faqs/list', requestBody);

    return response.data;
  } catch (error) {
    if (error.response) {
      const message = error.response.data?.message || `Server error: ${error.response.status}`;
      throw new Error(message);
    } else if (error.request) {
      throw new Error('Unable to reach the server. Please check your internet connection or try again later.');
    } else {
      throw new Error(error.message || 'An unexpected error occurred');
    }
  }
};

export const updateFaq = async (faqId, question, answer, order, is_active = true) => {
  try {
    const requestBody = {
      faq_id: faqId,
      question,
      answer,
      order,
      is_active: is_active !== undefined ? is_active : true,
    };

    const response = await api.put('/api/v1/admin/faqs', requestBody);

    return response.data;
  } catch (error) {
    if (error.response) {
      // Check for detailed validation errors
      const errorData = error.response.data;
      if (errorData?.errors && typeof errorData.errors === 'object') {
        // If there are field-specific errors, include them in the error message
        const errorMessages = Object.entries(errorData.errors)
          .map(([field, msg]) => `${field}: ${msg}`)
          .join(', ');
        throw new Error(errorMessages || errorData.message || `Server error: ${error.response.status}`);
      }
      const message = errorData?.message || `Server error: ${error.response.status}`;
      throw new Error(message);
    } else if (error.request) {
      throw new Error('Unable to reach the server. Please check your internet connection or try again later.');
    } else {
      throw new Error(error.message || 'An unexpected error occurred');
    }
  }
};

export const deleteFaq = async (faqId) => {
  try {
    const response = await api.delete(`/api/v1/admin/faqs/${faqId}`);

    return response.data;
  } catch (error) {
    if (error.response) {
      const message = error.response.data?.message || `Server error: ${error.response.status}`;
      throw new Error(message);
    } else if (error.request) {
      throw new Error('Unable to reach the server. Please check your internet connection or try again later.');
    } else {
      throw new Error(error.message || 'An unexpected error occurred');
    }
  }
};
